import React from 'react';
import PropTypes from 'prop-types';

import FilterCustom from 'components/common/FilterCustom';
import ProviderFilterForm from './ProviderFilterForm';

const ProviderFilter = ({ retrieveList, greyInput = true }) => {
  const onSubmitFilter = (values) => {
    retrieveList({
      filter: {
        filter: values,
        offset: 0,
      },
      isRefresh: true,
      keepFilter: false,
    });
  };

  const onClearFilter = () => {
    retrieveList({
      filter: {
        offset: 0,
      },
      isRefresh: true,
      keepFilter: false,
    });
  };

  return (
    <FilterCustom
      greyInput={greyInput}
      onSubmitFilter={onSubmitFilter}
      onClearFilter={onClearFilter}
    >
      <ProviderFilterForm />
    </FilterCustom>
  );
};

ProviderFilter.propTypes = {
  retrieveList: PropTypes.func,
  greyInput: PropTypes.bool,
};

export default ProviderFilter;
